import API from "../services/api-request";

export default {
  data() {
    return {
      showModal: false,
      showEditModal: false,
      title: "",
      titleUpdated: "",
      content: "",
      contentUpdated: "",
      news: [],
    };
  },
  methods: {
    showNewsModal() {
      this.showModal = true;
    },
    showEditNewsModal(id) {
      this.showEditModal = true;
      this.newsToEditId = id;
    },
    addNews() {
      this.showEditModal = false;

      let partnerId = sessionStorage.getItem("partnerId");
      API.store(
        {
          title: this.title,
          content: this.content,
          partner_id: partnerId,
        },
        "news"
      ).then((response) => {
        this.showModal = false;
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "News publié avec succès",
          showConfirmButton: false,
          timer: 1500,
        });
        this.allNews();
      });
    },
    editNews() {
      this.showEditModal = false;
      let partnerId = sessionStorage.getItem("partnerId");

      API.update(
        this.newsToEditId,
        {
          title: this.titleUpdated,
          content: this.contentUpdated,
        },
        "news"
      ).then((response) => {
        this.showModal = false;
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "News modifiée avec succès",
          showConfirmButton: false,
          timer: 1500,
        });
        this.allNews();
      });
    },
    deleteNews(id) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Êtes vous sûres ?",
          text: "Cet action sera irreversible!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "OUI, Supprimer!",
          cancelButtonText: "Non, Annuler!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            API.destroy(id, "news").then((response) => {
              swalWithBootstrapButtons.fire(
                "Supprimé!",
                "Ce news a été suprimé.",
                "success"
              );
              this.allNews();
            });
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    allNews() {
      API.index("news").then((response) => {
        this.news = response.data["data"];
      });
    },
  },
  mounted() {
    this.allNews();
  },
};
